var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "pagination mt-10",
      staticStyle: {
        "margin-top": "24px",
        color: "#606266",
        "font-size": "14px",
      },
    },
    [
      _c(
        "button",
        {
          class: ["turn", { turnTo: _vm.turnLeft }],
          attrs: { disabled: _vm.turnLeft },
          on: { click: _vm.last },
        },
        [_c("i", { staticClass: "el-icon el-icon-arrow-left" })]
      ),
      _c("div", { staticClass: "ml-10 mr-10" }, [
        _vm._v(_vm._s(_vm.pageNum) + "/" + _vm._s(_vm.pageCount)),
      ]),
      _c(
        "button",
        {
          class: ["turn", { turnTo: _vm.turnRight }],
          attrs: { disabled: _vm.turnRight },
          on: { click: _vm.next },
        },
        [_c("i", { staticClass: "el-icon el-icon-arrow-right" })]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }